import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Logger } from 'src/app/shared/tcs-logging/logger';
import { TcsConfigurationService } from 'src/app/core/configuration.service';
import { AttachmentEntityType } from 'src/graphql/generated/graphql.generated';
import { UserService } from '../tcs-identity/user.service';
import { FileUploader, IFileUploadRequest } from '../tcs-file-uploader/file-uploader';
import { FileValidator } from '../tcs-file-uploader/file-validator';

const maxSizeInBytes = 1024 * 1024 * 100; // 100 MB
export const defaultAllowedAttachmentExtensions = [
  'jpg',
  'jpeg',
  'png',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'txt',
  'mp4',
  'avi',
  'mov',
  'webm',
  'wmv',
];

@Injectable()
export class AttachmentUploaderService extends FileUploader {
  constructor(
    tcsConfig: TcsConfigurationService,
    http: HttpClient,
    user: UserService,
    logger: Logger,
  ) {
    super(`${tcsConfig.value.tcs.orgUri}/api/attachments/`, http, logger);

    this.setDefaultHeaders({
      Accept: 'application/json',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'x-company-id': `${user.user?.companyId}`,
    });
  }

  public validate(request: IFileUploadRequest, allowedFileTypes?: string[]): Error | null {
    return FileValidator.create({
      maxSizeInBytes,
      allowedFileExtensions: allowedFileTypes ?? defaultAllowedAttachmentExtensions,
    }).validate(request.file);
  }

  public uploadAttachment(
    entityType: AttachmentEntityType,
    entityId: string,
    file: File,
    allowedFileTypes?: string[],
  ) {
    const request: IFileUploadRequest = {
      file,
      resource: `${entityType}/${entityId}`,
    };
    this.uploadFile(request, allowedFileTypes);
  }
}
